import { Controller } from "@hotwired/stimulus"
var Highcharts = require('highcharts');  
// Load module after Highcharts is loaded
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);  

// Connects to data-controller="barchart"
export default class extends Controller {
  connect() {
    if (this.element.dataset.type == "barchart") {
        this.loadBarChart(this.element, this.element.dataset.serie)
    } else if (this.element.dataset.type == "columnchart") {
        this.loadColumnChart(this.element, this.element.dataset.serie)
    }
  }

  loadBarChart(element, serie) {
    Highcharts.chart(element.id, {
      title: null,
      chart: {
          type: 'bar'
      },
      colors: ["#8F8ACF"],
      xAxis: {
          categories: Object.keys(JSON.parse(serie)),
          title: null
      },
      yAxis: {
          title: null
      },
      legend: {
          enabled: false
      },
      series: [{
          name: "Total",
          data: Object.values(JSON.parse(serie))
      }],
      plotOptions: {
        bar: {
            point: {
                events: {
                    click: this.onBarchartClick,
                    }
                },
                cursor: "pointer"
            }
      }
    });
  }

  loadColumnChart(element, serie) {
    Highcharts.chart(element.id, {
        title: null,
        chart: {
            type: 'column'
        },
        colors: ["#8F8ACF"],
        xAxis: {
            categories: Object.keys(JSON.parse(serie)),
            crosshair: true
        },
        yAxis: {
            title: null
        },
        legend: {
            enabled: false
        },
        series: [{
            name: 'Total',
            data: Object.values(JSON.parse(serie))
        }],
        plotOptions: {
            column: {
                point: {
                    events: {
                        click: this.onColumnChartClick,
                        }
                    },
                    cursor: "pointer"
                }
          }
    });
  }

  onBarchartClick(e) {
    const filterData = e.point.custom
    const question = `Q_${filterData.question_id}`
    const url = new URL(document.URL)
    let currentQuestion = url.searchParams.get(question)
    let newQuestionFilter = ""

    if (currentQuestion) {
        currentQuestion += ` ${filterData.option_id}`
        currentQuestion = new Set(currentQuestion.split(" "))
        currentQuestion.forEach((option) => {
            newQuestionFilter += ` ${option}`
        })
        newQuestionFilter = newQuestionFilter.trim()
    } else {
        newQuestionFilter = `${filterData.option_id}`
    }

    url.searchParams.set(question, newQuestionFilter)

    const link = document.createElement('a');
    link.href = url.href
    link.click()
  }

  onColumnChartClick(e) {
    const value = e.point.category
    const question_max = `Q_${e.point.custom.question_id}_max`
    const question_min = `Q_${e.point.custom.question_id}_min`
    const url = new URL(document.URL)
    let currentQuestion_max = url.searchParams.get(question_max)
    let currentQuestion_min = url.searchParams.get(question_min)

    currentQuestion_min = currentQuestion_min == null ? value : currentQuestion_min
    currentQuestion_min = currentQuestion_min > value ? value : currentQuestion_min
    url.searchParams.set(question_min, currentQuestion_min)

    currentQuestion_max = currentQuestion_max == null ? value : currentQuestion_max
    currentQuestion_max = currentQuestion_max < value ? value : currentQuestion_max
    url.searchParams.set(question_max, currentQuestion_max)

    const link = document.createElement('a');
    link.href = url.href
    link.click()
  }
}